export const languageContent: any = {
  EN: {
    'welcomeText': 'Welcome!',
    'greatToHaveYou': 'It\'s great to have you at the IDP office today!',
    'nextButton': 'Next',
    'modeOfCounselling': 'Please select your preferred mode of counselling',
    'validationError': 'Please select your preferred mode of counselling. You can change this later'
  },

  ID_IND: {
    'welcomeText': 'Selamat datang!',
    'greatToHaveYou': 'Senang sekali Anda bisa hadir di kantor IDP hari ini!',
    'nextButton': 'Berikutnya',
    'modeOfCounselling': 'Silakan pilih metode konseling yang Anda inginkan',
    'validationError': 'Silakan pilih metode konseling yang Anda inginkan. Anda dapat mengubahnya nanti'
  },

  TH_THA: {
    'welcomeText': 'ยินดีต้อนรับ!',
    'greatToHaveYou': 'ดีใจที่ได้พบคุณที่สำนักงาน IDP วันนี้!',
    'nextButton': 'ถัดไป',
    'modeOfCounselling': 'โปรดเลือกช่องทางขอรับคำปรึกษา',
    'validationError': 'กรุณาเลือกวิธีการรับคำปรึกษาที่คุณต้องการ คุณสามารถเปลี่ยนได้ภายหลัง'
  },

  KR_KOR: {
    'welcomeText': '환영합니다!',
    'greatToHaveYou': 'IDP 한국지사에 방문해 주셔서 감사드립니다!',
    'nextButton': '다음',
    'modeOfCounselling': '원하시는 상담방법을 선택해주세요.',
    'validationError': '선호하는 상담 방식을 선택해 주세요. 나중에 변경할 수 있습니다'
  },

  TW_CHI: {
    'welcomeText': '歡迎！',
    'greatToHaveYou': '很高興能見到你來到 IDP 辦公室！',
    'nextButton': '下一頁',
    'modeOfCounselling': '請選擇您喜歡的諮詢方式',
    'validationError': '請選擇您偏好的諮詢方式。您可以稍後更改'
  },

  HK_CHI: {
    'welcomeText': '歡迎！',
    'greatToHaveYou': '很高興今天你來到 IDP 辦事處！',
    'nextButton': '下一頁',
    'modeOfCounselling': '請選擇您喜歡的諮詢方式',
    'validationError': '請選擇您偏好的諮詢方式。您可以稍後更改'
  },

  HK_ZK: {
    'welcomeText': '欢迎！',
    'greatToHaveYou': '很高兴今天你来到 IDP 办事处！',
    'nextButton': '下一页',
    'modeOfCounselling': '请选择您喜欢的咨询方式',
    'validationError': '请选择您偏好的咨询方式。您可以稍后更改'
  },

  CN_CHI: {
    'welcomeText': '歡迎！',
    'greatToHaveYou': '很高興今天你來到 IDP 辦事處！',
    'nextButton': '下一頁',
    'modeOfCounselling': '請選擇您喜歡的諮詢方式',
    'validationError': '請選擇您偏好的諮詢方式。您可以稍後更改'
  },

  CN_ZK: {
    'welcomeText': '欢迎！',
    'greatToHaveYou': '很高兴今天你来到 IDP 办事处！',
    'nextButton': '下一页',
    'modeOfCounselling': '请选择您喜欢的咨询方式',
    'validationError': '请选择您偏好的咨询方式。您可以稍后更改'
  }
}
